import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AccountInfo } from "@azure/msal-browser";
import { FallbackSpinner } from "components/FallbackSpinner/FallbackSpinner";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import { MSGraphAuth } from "./service/GraphService";
import "react-quill-new/dist/quill.snow.css";
import * as Sentry from "@sentry/react";
import { initializeIcons } from "@fluentui/react";

// Initialize Fluent UI icons
initializeIcons();

// Sentry.init({
//   dsn: "https://d6430f384918d90941ae5dca7fc096e7@o4510322930286592.ingest.de.sentry.io/4510322933301328",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.browserProfilingIntegration(),
//     Sentry.replayIntegration(),
//     Sentry.consoleLoggingIntegration({
//       levels: ["log", "warn", "error", "info"],
//     }),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     "localhost",
//     /^https:\/\/shared-d-we-api.azure-api.net\/qtg\/bff\/v1/,
//   ],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
//   profilesSampleRate: 1.0,

//   // Enable logs to be sent to Sentry
//   enableLogs: true,
// });
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnMount: true, // Allow refetch on mount for stale data
      refetchIntervalInBackground: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // Data becomes stale after 5 minutes
      gcTime: 10 * 60 * 1000, // Keep unused data in cache for 10 minutes
    },
  },
});

const startApplication = () => {
  //console.log("startApplication");
  root.render(
    <React.Fragment>
      <Suspense fallback={<FallbackSpinner />}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Suspense>
    </React.Fragment>
  );
};

// Check if this is the invoice payment page - if so, skip authentication
const isInvoicePaymentPage =
  window.location.pathname.startsWith("/invoice-payment/");

if (isInvoicePaymentPage) {
  // Start app immediately without authentication for invoice payment page
  startApplication();
} else {
  // For all other routes, require authentication
  MSGraphAuth?.accountObj
    .then((accountInfo: AccountInfo | null) => {
      if (accountInfo) {
        startApplication();
      } else {
        MSGraphAuth.login();
      }
    })
    .catch((error: any) => {
      if (error === "There isn't any account detected.") {
        MSGraphAuth.login();
      } else {
        // console.log(error);
      }
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
